import { render } from "./sucursalForm.vue?vue&type=template&id=5fd89bba&scoped=true"
import script from "./sucursalForm.vue?vue&type=script&lang=js"
export * from "./sucursalForm.vue?vue&type=script&lang=js"

import "./sucursalForm.vue?vue&type=style&index=0&id=5fd89bba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd89bba"]])

export default __exports__